import React from "react";
import { formatDate } from "../../utils/dateFormatting";
import useTranslation from "../../hooks/useTranslation";

export default function UpcomingAppointmentsCard({ appointments }) {
  const { t } = useTranslation();
  const formatDateWithDash = (dateStr, timeStr) => {
    const formatted = formatDate(dateStr);
    if (!formatted) return null;
    return timeStr ? `${formatted} - ${timeStr}` : formatted;
  };
  const upcomingAppointments = appointments
    .filter(a => {
      if (!a.date) return false;
      try {
        const apptDate = new Date(a.date);
        apptDate.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (apptDate > today) return true;
        if (apptDate.getTime() === today.getTime() && a.time) {
          try {
            const [hours, minutes] = a.time.split(':');
            const apptDateTime = new Date(a.date);
            apptDateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
            const now = new Date();
            return apptDateTime >= now;
          } catch (e) {
            return true;
          }
        }
        if (apptDate.getTime() === today.getTime()) return true;
        return false;
      } catch (e) {
        return false;
      }
    })
    .sort((a, b) => {
      try {
        const dateA = new Date(a.date + ' ' + (a.time || '00:00'));
        const dateB = new Date(b.date + ' ' + (b.time || '00:00'));
        return dateA - dateB;
      } catch (e) {
        return 0;
      }
    })
    .slice(0, 10);

  return (
    <div className="admin-panel" style={{ marginTop: 12 }}>
      <div className="admin-panel-title">{t('Upcoming Appointments')}</div>
      <div style={{ maxHeight: 260, overflowY: 'auto' }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>{t('Patient')}</th>
              <th>{t('Doctor')}</th>
              <th>{t('Date / Time')}</th>
            </tr>
          </thead>
          <tbody>
            {upcomingAppointments.length === 0 ? (
              <tr>
                <td colSpan="3" className="admin-muted">{t('No upcoming appointments')}</td>
              </tr>
            ) : (
              upcomingAppointments.map(a => (
                <tr key={a.id}>
                  <td>{a.patient_name}</td>
                  <td>{a.doctor_name}</td>
                  <td>{formatDateWithDash(a.date, a.time)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
